import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators, FormGroup } from '@angular/forms';

import { EditFieldsModal } from '../modals/edit-fields-modal/edit-fields-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { RequestService } from '../../services/request.service';
import { LibService } from '../../services/libService';
import { ActionService } from '../../services/action.service';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
  selector: 'app-request-edit-fields-button',
  templateUrl: './request-edit-fields-button.component.html',
  styleUrls: ['./request-edit-fields-button.component.scss']
})
export class RequestEditFieldsButtonComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() components: any;
  @Input() fieldsToActivate: any = [];
  @Input() options: any = {};

  constructor(
    private dialog: MatDialog,
    private requestService: RequestService,
    private libService: LibService,
    private actionService: ActionService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log('ngOnChanges request edit fields button')
  }

  ngOnInit(): void {
    //console.log('ngOnInit request edit fields button')
    console.log('this.components')
    console.log(this.components)
  }

  setDisabled() {
    return this.fieldsToActivate?.length == 0
  }

  buttonVisibility(){
    return !this.components.codes.includes("request_save_button") && this.checkPermissions("actions_can_always_edit_the_marketing_template_fields")
  }

  checkPermissions(key: string) {
    return this.actionService.checkPermissions(key)
  }

  openEditFieldsModal() {

    let dataStructure: any = {
      fieldsToActivate: this.fieldsToActivate,
      options: this.options,
    }

    const dialogRef = this.dialog.open(EditFieldsModal, {
      width: '400px',
      data: dataStructure,
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (![null, undefined].includes(result)) {

        let requestId = this.form?.get('id')?.value
        let attributes: any = {}
        this.fieldsToActivate.forEach((field: any) => {
          switch (field) {
            case 'marketingNoteId':
              attributes[field] = result[field]?.id;
              break;
            case 'origin':
              attributes[field] = result[field]?.origin
              break;
            case 'contactChannel':
              attributes[field] = result[field]?.name;
              break;
          }

        });

        this.libService.lockPage('');

        this.requestService.editFields(requestId, attributes).subscribe((res: any) => {
          this.fieldsToActivate.forEach((field: any) => {
            this.form.controls[field]?.patchValue(res[field])
          });
          this.libService.unlockPage();
        })




      }

    });
  }

}
